import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";

(function ($, Drupal, drupalSettings) {
  "use strict";

  $('body').on('click', '.saipem-peolpe--video', function(e){
    e.preventDefault();
    let videoID = $(this).data('videoid');
    let height = $(window).width() > 990 ? "327" : "260";
    let htmlFrame = '<iframe width="100%" height="'+height+'" src="https://www.youtube-nocookie.com/embed/'+videoID+'?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>';
    $(this).replaceWith(htmlFrame);
  });

})(jQuery, Drupal, drupalSettings);